import { render } from "./i-cpf.vue?vue&type=template&id=bf30ff48"
import script from "./i-cpf.vue?vue&type=script&lang=js"
export * from "./i-cpf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__